import { TRANSFER_LIMITS } from "../lib/transfers.ts";

export function effectiveDpi(logoWidthPx: number, widthIn: number): number {
  return Math.floor(logoWidthPx / widthIn);
}

export type DpiVerdict = "ok" | "warn" | "block";

export function dpiVerdict(dpi: number): DpiVerdict {
  if (dpi >= 300) return "ok";
  if (dpi >= 150) return "warn";
  return "block";
}

// The warnings a print carries on its order item: how its background was handled, and a low resolution. A garment
// print is low under the Studio's 300 DPI line; a transfer under the transfer sharp line (it was already refused
// under 150 DPI, since it prints exactly as uploaded). Fix re-renders and design orders both use this.
export function printWarnings(
  logo: { background_removed: boolean; background_detected: boolean }, dpi: number, kind: "apparel" | "transfer",
): string[] {
  const warnings: string[] = [];
  if (logo.background_removed) warnings.push("background_removed");
  else if (logo.background_detected) warnings.push("background_kept");
  const low = kind === "transfer" ? dpi < TRANSFER_LIMITS.sharpDpi : dpiVerdict(dpi) !== "ok";
  if (low) warnings.push(`low_resolution:${dpi}`);
  return warnings;
}

export interface SpotLimits {
  maxWidthIn: number;
  maxHeightIn: number;
}

const floor2 = (n: number) => Math.floor(n * 100 + 1e-9) / 100;

export function fitPrintSize(
  aspect: number,
  requestedWidthIn: number,
  spot: SpotLimits,
  printerMaxWidthIn: number,
): { widthIn: number; heightIn: number; clamped: boolean } {
  if (!(requestedWidthIn > 0) || !(aspect > 0)) throw new Error("Print width and aspect must be positive");
  let width = Math.min(requestedWidthIn, spot.maxWidthIn, printerMaxWidthIn);
  if (width * aspect > spot.maxHeightIn) width = spot.maxHeightIn / aspect;
  const widthIn = floor2(width);
  const heightIn = floor2(widthIn * aspect);
  return { widthIn, heightIn, clamped: widthIn < requestedWidthIn - 0.005 };
}
